import { render, staticRenderFns } from "./UsersOctagon.vue?vue&type=template&id=c54523e8"
import script from "./UsersOctagon.vue?vue&type=script&lang=js"
export * from "./UsersOctagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports